import { render, staticRenderFns } from "./FavoriteTemplate.vue?vue&type=template&id=3ea8fb90&scoped=true&lang=pug"
import script from "./FavoriteTemplate.vue?vue&type=script&lang=js"
export * from "./FavoriteTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea8fb90",
  null
  
)

export default component.exports